
import Banner from "../components/banner/Banner";
import Footer from "../components/footer/Footer";

import Navbar from "../components/navbar/Navbar";

import { useEffect } from "react";

import Privacy from "../components/Privacy";


const PrivacyPolicy=()=>{
      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return(
        <div className="">
<Navbar/>
 <Banner title="Privacy policy"/>

<Privacy/>
<Footer/>

</div>
    )
}
export default PrivacyPolicy;